import VALUES from 'core/data-model/constants/values'
import { getServiceWrapper } from 'core/service-wrapper'
import {
  getOccupationForRidersInTypeArray,
  getRiders,
  mergeRiderArray,
} from 'e-submission/sagas/policy-payload/rider-selector'
import { modelFactorToPaymentMode } from './coverageplan'
import { currentQQ, currentQQUsePartnerApi } from './primitive-selector'

export const getDisplayProductQuery = (state) => {
  const selectedDisplayProduct = currentQQ('selectedDisplayProduct')(state)
  return {
    code:
      selectedDisplayProduct.category === VALUES.MRTA
        ? selectedDisplayProduct.basicPlanCode
        : selectedDisplayProduct.code,
    type: selectedDisplayProduct.type,
  }
}

export const getNatureOfDutyCodes = (state) => {
  return [currentQQ('insured.occupation.natureOfDuty.code')(state)]
}

const getPensionType = (state) => {
  return currentQQ('coveragePlan.pensionType')(state)
}

const getCategoryForDisplayProduct = (state) => {
  return currentQQ('selectedDisplayProduct.category')(state)
}

export const coveragePlanMRTA = async (state) => {
  const serviceWrapper = getServiceWrapper()
  const usePartnerApi = currentQQUsePartnerApi(state)

  const sumAssured = currentQQ('coveragePlan.selectedBasicPlan.sumAssured.value')(state)
  let sumAssuredContract, paymentPeriodCode
  if (usePartnerApi) {
    sumAssuredContract = currentQQ('biProps.data.sumAssuredContract')(state)
    paymentPeriodCode = currentQQ('biProps.data.paymentPeriodCode')(state)
  } else {
    sumAssuredContract = currentQQ('biProps.sumAssuredContract')(state)
  }

  const selectedModelFactorID = currentQQ('coveragePlan.selectedModelFactorID')(state)
  const paymentMode = modelFactorToPaymentMode(selectedModelFactorID)
  const riders = getRiders(state)
  const displayProductQuery = getDisplayProductQuery(state)
  const natureOfDutyCodes = getNatureOfDutyCodes(state)
  const occupationFactor = await serviceWrapper.getRiskiestOccupation(displayProductQuery, natureOfDutyCodes)
  const riskiestOccupationFactorForRiders = await serviceWrapper.getRiskiestOccupationFactorForRiders(
    displayProductQuery,
    natureOfDutyCodes,
    riders
  )

  let coveragePlanPayload = {
    basicPlan: {
      sumAssured,
      sumAssuredContract,
      occupationFactor,
    },
    paymentMode,
    paymentPeriodCode,
    riders: mergeRiderArray(riders, getOccupationForRidersInTypeArray(riskiestOccupationFactorForRiders)),
  }

  if (
    getCategoryForDisplayProduct(state) === VALUES.RETIREMENT ||
    getCategoryForDisplayProduct(state) === VALUES.BUMNAN_READY
  ) {
    Object.assign(coveragePlanPayload, { pensionType: getPensionType(state) })
  }
  return coveragePlanPayload
}

export const coveragePlan = async (state) => {
  const serviceWrapper = getServiceWrapper()
  const usePartnerApi = currentQQUsePartnerApi(state)
  let paymentPeriodCode

  if (usePartnerApi) {
    paymentPeriodCode = currentQQ('biProps.data.paymentPeriodCode')(state)
  }

  const sumAssured = currentQQ('coveragePlan.selectedBasicPlan.sumAssured.value')(state)
  const selectedModelFactorID = currentQQ('coveragePlan.selectedModelFactorID')(state)
  const paymentMode = modelFactorToPaymentMode(selectedModelFactorID)
  const riders = getRiders(state)
  const displayProductQuery = getDisplayProductQuery(state)
  const natureOfDutyCodes = getNatureOfDutyCodes(state)
  const occupationFactor = await serviceWrapper.getRiskiestOccupation(displayProductQuery, natureOfDutyCodes)
  const riskiestOccupationFactorForRiders = await serviceWrapper.getRiskiestOccupationFactorForRiders(
    displayProductQuery,
    natureOfDutyCodes,
    riders
  )

  let coveragePlanPayload = {
    basicPlan: {
      sumAssured,
      occupationFactor,
    },
    paymentMode,
    paymentPeriodCode,
    riders: mergeRiderArray(riders, getOccupationForRidersInTypeArray(riskiestOccupationFactorForRiders)),
  }

  if (
    getCategoryForDisplayProduct(state) === VALUES.RETIREMENT ||
    getCategoryForDisplayProduct(state) === VALUES.BUMNAN_READY
  ) {
    Object.assign(coveragePlanPayload, { pensionType: getPensionType(state) })
  }
  return coveragePlanPayload
}
